import { TreeRow } from './documentTreeTypes'

// Custom dataTransfer type marking a drag that originates from the documents tree, so the
// drop handler (and the upload Dropzone) can tell internal moves apart from OS file drags.
export const HAMMOCK_DRAG_MIME = 'application/x-hammock-ids'

// Dragging a selected row takes the whole selection along; dragging an unselected row
// moves just that row without touching the selection.
export const getDragIds = (selectedIds: ReadonlySet<string>, draggedId: string): string[] => {
    return selectedIds.has(draggedId) ? [...selectedIds] : [draggedId]
}

// True when dropping on `targetId` would move a folder into itself or into one of its own
// descendants. Walks the parent chain from the target up; hitting a dragged id means the
// target lives inside the dragged subtree.
export const isRecursiveDrop = (draggingIds: ReadonlySet<string>, targetId: string, parentById: ReadonlyMap<string, string | undefined>): boolean => {
    let current: string | undefined = targetId
    const guard = new Set<string>()
    while (current !== undefined) {
        if (draggingIds.has(current)) {
            return true
        }
        if (guard.has(current)) {
            return false
        }
        guard.add(current)
        current = parentById.get(current)
    }
    return false
}

export const canDropInto = (target: TreeRow, draggingIds: ReadonlySet<string>, parentById: ReadonlyMap<string, string | undefined>): boolean => {
    return target.isFolder && draggingIds.size > 0 && !isRecursiveDrop(draggingIds, target.id, parentById)
}

// True when dropping on the empty container space (= the dossier root) would actually move
// something: at least one dragged item lives below the top level. Items whose parent is the
// root — or unknown — are already at the top level and are skipped.
export const canDropOnRoot = (draggingIds: ReadonlySet<string>, rootId: string, parentById: ReadonlyMap<string, string | undefined>): boolean => {
    return [...draggingIds].some(id => {
        const parentId = parentById.get(id)
        return parentId !== undefined && parentId !== rootId
    })
}
